export default __webpack_public_path__ + "static/media/GooglePlayBadge.e7092d24.png";